<!-- 由 suu 创建于 2022-09-02 星期五 -->
<template>
  <div class="summary-list">
    <van-tabs v-model="active" sticky color="#6236FF">
      <van-tab title="周总结">
        <week-summary-list></week-summary-list>
      </van-tab>
      <van-tab title="结营总结">
        <EndCampList />
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import WeekSummaryList from './week-summary-list.vue'
import EndCampList from './end-camp-list.vue'
export default {
  name: 'summary-list',

  components: { WeekSummaryList, EndCampList },

  props: {},

  data() {
    return {
      active: 0
    }
  },

  computed: {},

  watch: {},

  created() {
    this.active = this.$route.query.tab && Number(this.$route.query.tab)
  },

  mounted() {},

  destroyed() {},

  methods: {}
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.summary-list {
  width: 100vw;
  min-height: 100vh;
  background-color: #f9f9f9;
  position: relative;
  // padding-bottom: 30px;
  @include paddingBottom(30px);
  box-sizing: border-box;
  ::v-deep {
  }
}
</style>
